// converts a data url to a file as S3 bucket requires a file type
export function dataURLtoFileConverter(dataUrl: string, fileName: string) {
  const arr = dataUrl.split(',')
  const mime = arr[0].match(/:(.*?);/)![1]
  const bstr = atob(arr[arr.length - 1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while(n--){
      u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], fileName, {type: mime})
}